<template>
  <div ref="countdownRef" class="countdown-parallax-container">
    <div class="parallax-background">
      <div class="overlay"></div>
    </div>

    <div class="countdown-wrapper">
      <!-- MENTI-MENSAJE SUPERIOR -->
      <p ref="invitacionRef" class="texto-invitacion">
        Con alegría, los invitamos<br />
        a la celebración de nuestro matrimonio.
      </p>

      <!-- BANNER DE FECHA VERDE OLIVA -->
      <div ref="fechaBannerRef" class="fecha-banner">
        <p class="sabado-texto">SÁBADO</p>
        <p class="fecha-completa-texto">14 DE NOVIEMBRE DE 2026</p>
        <div class="separador-linea-punto">
          <span class="linea"></span>
          <span class="punto"></span>
          <span class="linea"></span>
        </div>
      </div>

      <!-- FOTO PRINCIPAL A TODO LO ANCHO -->
      <div ref="fotoWrapperRef" class="foto-wrapper">
        <img src="@/assets/image7 (1).webp" alt="Foto Novios" class="foto-full" />
      </div>

      <!-- SECCIÓN CONTADOR -->
      <div ref="contadorSeccionRef" class="contador-seccion">
        <p class="faltan">¡Solo Faltan!</p>

        <div class="countdown">
          <div class="item">
            <span class="fa-font">{{ days }}</span>
            <label>DÍAS</label>
          </div>
          <div class="separador-vertical"></div>

          <div class="item">
            <span class="fa-font">{{ hours }}</span>
            <label>HORAS</label>
          </div>
          <div class="separador-vertical"></div>

          <div class="item">
            <span class="fa-font">{{ minutes }}</span>
            <label>MINUTOS</label>
          </div>
          <div class="separador-vertical"></div>

          <div class="item">
            <span class="fa-font">{{ seconds }}</span>
            <label>SEGUNDOS</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'ContadorPersonalizado',
  setup() {
    const countdownRef = ref(null);
    const invitacionRef = ref(null);
    const fechaBannerRef = ref(null);
    const fotoWrapperRef = ref(null);
    const contadorSeccionRef = ref(null);

    const days = ref('00');
    const hours = ref('00');
    const minutes = ref('00');
    const seconds = ref('00');
    let interval;

    const updateCountdown = () => {
      const eventDate = new Date('2026-11-14T18:00:00');
      const now = new Date();
      const diff = eventDate - now;

      if (diff <= 0) {
        days.value = hours.value = minutes.value = seconds.value = '00';
        clearInterval(interval);
        return;
      }

      days.value = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, '0');
      hours.value = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, '0');
      minutes.value = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, '0');
      seconds.value = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');
    };

    const animateCountdown = () => {
      // Estado inicial GSAP
      gsap.set([
        invitacionRef.value,
        fechaBannerRef.value,
        fotoWrapperRef.value,
        contadorSeccionRef.value
      ], {
        opacity: 0,
        y: 35
      });

      const tl = gsap.timeline({
        defaults: {
          ease: 'power2.out',
          duration: 1
        }
      });

      tl.to(invitacionRef.value, {
        opacity: 1,
        y: 0
      })
      .to(fechaBannerRef.value, {
        opacity: 1,
        y: 0
      }, '>-0.5')
      .to(fotoWrapperRef.value, {
        opacity: 1,
        y: 0
      }, '>-0.5')
      .to(contadorSeccionRef.value, {
        opacity: 1,
        y: 0
      }, '>-0.5');
    };

    onMounted(async () => {
      await nextTick();
      updateCountdown();
      interval = setInterval(updateCountdown, 1000);

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateCountdown();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      if (countdownRef.value) observer.observe(countdownRef.value);
    });

    onBeforeUnmount(() => {
      clearInterval(interval);
    });

    return {
      countdownRef,
      invitacionRef,
      fechaBannerRef,
      fotoWrapperRef,
      contadorSeccionRef,
      days,
      hours,
      minutes,
      seconds
    };
  }
};
</script>

<style scoped>
.countdown-parallax-container {
  position: relative;
  width: 100%;
 background-color: #F4F1E9; ; 
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.countdown-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 500px;
  text-align: center;
}

/* MENSAJE DE INVITACIÓN */
.texto-invitacion {
  font-family: 'Playfair Display', serif;
  font-size: 19px;
  color: #55534e;
  line-height: 1.5;
  margin-bottom: 25px;
  padding: 0 20px;
  letter-spacing: 0.5px;
}

/* BANNER FECHA (VERDE OLIVA) */
.fecha-banner {
  background-color: #656952;
  color: #f3efe6;
  padding: 25px 20px;
  position: relative;
  margin-bottom: 0;
}

.linea-decorativa-superior,
.linea-decorativa-inferior {
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #c9b072;
}

.linea-decorativa-superior {
  top: 4px;
}

.linea-decorativa-inferior {
  bottom: 4px;
}

.sabado-texto {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  letter-spacing: 4px;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.fecha-completa-texto {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  letter-spacing: 3px;
  font-weight: 500;
  margin-bottom: 12px;
}

.separador-linea-punto {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 180px;
  margin: 0 auto;
}

.separador-linea-punto .linea {
  flex: 1;
  height: 1px;
  background-color: #c9b072;
}

.separador-linea-punto .punto {
  width: 5px;
  height: 5px;
  background-color: #c9b072;
  border-radius: 50%;
}

/* FOTO PRINCIPAL A TODO LO ANCHO */
.foto-wrapper {
  width: 100%;
  line-height: 0;
}

.foto-full {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* CONTADOR Y "¡SOLO FALTAN!" */
.contador-seccion {
  padding: 30px 15px;
  background-color: #f7f4ef;
}

.faltan {
  font-family: 'corinthia', cursive, 'Playfair Display', serif;
  font-size: 42px;
  color: #C6A66A ;
  margin-bottom: 20px;
  line-height: 1;
}

.countdown {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 55px;
}

.fa-font {
  font-size: 34px;
  color: #4a4d3d;
  font-family: 'padres', serif;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 6px;
}

.item label {
  font-size: 11px;
  letter-spacing: 2px;
  color: #66645e;
  font-family: 'Playfair Display', serif;
}

.separador-vertical {
  width: 1px;
  height: 35px;
  background-color: #7A3D48;
}

@media (max-width: 600px) {
  .texto-invitacion {
    font-size: 17px;
  }

  .fecha-completa-texto {
    font-size: 17px;
    letter-spacing: 2px;
  }

  .faltan {
    font-size: 36px;
  }

  .fa-font {
    font-size: 28px;
  }

  .item label {
    font-size: 10px;
  }
}
</style>